import { render, staticRenderFns } from "./PagePersonal.vue?vue&type=template&id=0b7a9459&"
import script from "./PagePersonal.vue?vue&type=script&lang=js&"
export * from "./PagePersonal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports